import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, useParams } from 'react-router-dom';

import { Box, Stack } from '@mui/material';
import moment from 'moment';

import { ViewItem, FormCard } from '@/components';
import { DATE_TIME_FORMAT } from '@/config';
import { PageBackHeader } from '@/layouts/TabLayout';
import { towingRecordDummyData } from '@/pages/Tools/TowingManagement/data';

export const TowRecordDetailsPage = () => {
  const { id } = useParams();
  const [record, setRecord] = useState<any | null>(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const match = towingRecordDummyData.find((r) => r.id === id);
    if (match) setRecord(match);
  }, [id]);

  if (!record) return null;

  const onGoBack = () => {
    const searchValue = searchParams.get('search');
    const searchQuery = searchValue
      ? `&search=${encodeURIComponent(searchValue)}`
      : '';
    navigate(`/tools/towing-management?tab=records${searchQuery}`);
  };

  return (
    <>
      <PageBackHeader
        title="View Tow Record"
        goBack={onGoBack}
        style={{ fontWeight: 600, fontSize: '20px' }}
      />
      <Stack overflow="auto">
        <Box sx={{ borderRadius: 2, p: 3 }}>
          <FormCard title="Tow Record Overview" className="grey-title">
            <ViewItem
              label="Date and Time"
              value={moment(record.date).format(DATE_TIME_FORMAT)}
              md={6}
            />
            <ViewItem label="Tow Type" value={record.type} md={6} />

            <ViewItem label="Officer Name" value={record.initiator} md={6} />
            <ViewItem label="Badge Number" value={record.badgeNumber} md={6} />

            <ViewItem
              label="License Plate"
              value={record.licensePlate}
              md={6}
            />
            <ViewItem label="VIN" value={record.vin} md={6} />
            <ViewItem label="Year" value={record.year} md={4} />
            <ViewItem label="Make" value={record.make} md={4} />
            <ViewItem label="Model" value={record.model} md={4} />
            <ViewItem label="Color" value={record.color} md={6} />

            <ViewItem
              label="Tow From Location"
              value={record.towFromLocation}
              md={6}
            />
            <ViewItem label="Destination" value={record.destination} md={6} />
            <ViewItem
              label="Towing Company"
              value={record.towingCompany}
              md={6}
            />
            <ViewItem label="Status" value={record.status} md={6} />
            <ViewItem label="Reason to Tow" value={record.reason} md={12} />

            <ViewItem
              label="Estimated Cost"
              value={record.estimatedCost}
              md={6}
            />
            <ViewItem label="Actual Cost" value={record.actualCost} md={6} />
            <ViewItem
              label="Additional Notes"
              value={record.additionalNotes}
              md={12}
            />
          </FormCard>
        </Box>
      </Stack>
    </>
  );
};
